var _a;
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
const initBanner = () => {
    return new Swiper('.js-experts-slider', {
        slidesPerView: 1,
        spaceBetween: 32,
        navigation: {
            nextEl: '.experts-button-next',
            prevEl: '.experts-button-prev',
        },
        pagination: {
            el: '.experts-pagination',
            type: 'bullets',
            clickable: true,
        },
        modules: [Navigation, Pagination],
        breakpoints: {
            991: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 2,
            },
        },
    });
};
document.addEventListener('DOMContentLoaded', initBanner, false);
if (window['acf']) {
    (_a = window['acf']) === null || _a === void 0 ? void 0 : _a.addAction('render_block_preview', initBanner);
}
document.addEventListener('DOMContentLoaded', () => {
    var _a;
    const firstBanner = document.querySelector('.banner');
    if (!firstBanner)
        return;
    const bannersWrapper = document.createElement('div');
    bannersWrapper.classList.add('container', 'banners-wrapper');
    (_a = firstBanner.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(bannersWrapper, firstBanner);
    const banners = document.querySelectorAll('.banner');
    banners.forEach(banner => {
        bannersWrapper.appendChild(banner);
    });
});
document.addEventListener('DOMContentLoaded', () => {
    const banners = document.querySelectorAll('.banner');
    if (banners.length === 0)
        return;
    const checkBannerPosition = () => {
        const windowHeight = window.innerHeight;
        banners.forEach(banner => {
            const bannerRect = banner.getBoundingClientRect();
            const isCenter = ((bannerRect.top >= 0 && bannerRect.top <= windowHeight / 2) ||
                (bannerRect.bottom >= windowHeight / 2 && bannerRect.bottom <= windowHeight));
            if (isCenter) {
                banner.classList.add('center');
            }
            else {
                banner.classList.remove('center');
            }
        });
    };
    window.addEventListener('scroll', checkBannerPosition);
    window.addEventListener('resize', checkBannerPosition);
    checkBannerPosition();
});
